import { Location } from '@angular/common';
import { Component, OnInit, ElementRef, AfterViewInit, Renderer2, ViewChild, TemplateRef } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ROUTES } from '../../constants/routes';
import { TranslateService } from '@ngx-translate/core';
import { ProjectsService } from '../../services/projects/projects.service';
import { LocalStorageService } from '../../services/local-storage/local-storage.service';
import { Project } from '../../interfaces/project';
import { TranslationService } from 'src/app/services/translate/translation.service';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.css"]
})
export class NavbarComponent implements OnInit, AfterViewInit {
  public isCollapsed = false;
  private listTitles: any[];
  public location: Location;
  private sidebarVisible: boolean;
  private mobile_menu_visible: any = 0;
  private toggleButton: any;
  public SelectedProject: Project;

  public platform = Capacitor.getPlatform();
  @ViewChild('mobile', {static: true}) mobile: TemplateRef<any>| null = null;

  /**
   * @constructor
   * @param {ProjectsService} _project
   * @param {Router} _router
   * @param {Location} _location
   * @param {ElementRef} _element
   * @param {TranslateService} _translate
   * @param {LocalStorageService} _localStorage
   */
  constructor(
    public _project: ProjectsService,
    private _router: Router,
    private _location: Location,
    private _element: ElementRef,
    private _translate: TranslateService,
    private _translation: TranslationService,
    private _localStorage: LocalStorageService,
  ) {
    this.sidebarVisible = true;
  }

  /**
   * On Init
   * @return {void}
   */
  ngOnInit(): void {
    this.listTitles = ROUTES.filter(listTitle => listTitle);
    const navbar: HTMLElement = this._element.nativeElement;
    this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];
    // this._router.events.subscribe((event) => {
    //   this.sidebarClose();
    //   let $layer: any = document.getElementById('bodyClick');
    //   if ($layer) {
    //     $layer.remove();
    //     this.mobile_menu_visible = 0;
    //   }
    // });
    // this._project.getSelectedProject;
  }

  /**
   * After View Init
   * @return {void}
   */
  ngAfterViewInit(): void {
    this._translate.addLangs(['es', 'en', 'por']);

    const navbar: HTMLElement = this._element.nativeElement;
    this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];

    this.colorIconWorld();

    this.sidebarCloseCleanup();

    this._router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.colorIconWorld();
        this.sidebarCloseCleanup();
      }
    });

    // Method 1
    // this.colorIconWorld();
    // this._router.events.subscribe(event => {
    //   if (event instanceof NavigationEnd) {
    //     this.colorIconWorld();
    //   }
    // });

    // Method 2
    // const navbar: HTMLElement = this._element.nativeElement;
    // this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];
    // this._router.events.subscribe((event) => {
    //   this.sidebarClose();
    //   let $layer: any = document.getElementById('bodyClick');
    //   if ($layer) {
    //     $layer.remove();
    //     this.mobile_menu_visible = 0;
    //   }
    // });
  }

  /**
   * Valida sí, dependiendo la URL, se puede mostrar el Navbar
   * @returns {string}
   */
  public get canShowNavbar(): boolean {
    const RoutesExcluded: Array<string> = ['/login', '/register'];
    const CurrentRoute: string = this._router.url;
    return RoutesExcluded.includes(CurrentRoute) || CurrentRoute.includes('/transfer');
  }

  /**
   * Obtiene el titulo de la página de acuerdo a la URL
   * @returns {string}
   */
  public get getTitle(): string {
    let title: string = this._location.prepareExternalUrl(this._location.path());
    if (title.charAt(0) === '#') title = title.slice(1);
    for (const Title of this.listTitles) {
      if(Title.type === 'link' && Title.path === title) {
        if(Title.title === 'CUSTOM_BLOCKS') {
          return `Sidebar.${Title.title}`;
        } else return Title.title;
      } else if (Title.type === 'sub') {
        for (const Child of Title.children) {
          const Subtitle = `${Title.path}/${Child.path}`;
          if (Subtitle === title) return `Pages.${Child.title}`;
        }
      }
    }
    return 'Pages.DASHBOARD';
  }

  /**
   * Cambia el color el icono que controla los idiomas, dependiendo de la pagina en la que se encuentre.
   */
  public colorIconWorld() {
    const Dashboard: string = this._router.url;
    const Element: HTMLElement = document.getElementById('world');
    const ElementDropdown: HTMLElement = document.getElementById('dropdownBasic1')
    if (Dashboard === '/dashboard') {
      Element.style.setProperty('color', 'black');
      ElementDropdown.style.setProperty('color', 'black');
    } else {
      Element.style.setProperty('color', 'white');
      ElementDropdown.style.setProperty('color', 'white');
    }
  }

  /**
   * Inica la rotacion del icono de traduccion
   * @returns {void}
   */
  public rotateIcon(): void {
    const Icon_world: HTMLElement = event.currentTarget as HTMLElement;
    Icon_world.classList.add('rotate-on-hover');
  }

  /**
   * Para la rotacion del icono de traduccion
   * @returns {void}
   */
  public stopRotation(): void {
    const Icon_world: HTMLElement = event.currentTarget as HTMLElement;
    Icon_world.classList.remove('rotate-on-hover')
  }

  /**
   * Configura el menú despegable, solo versión responsive
   * @returns {void}
   */
  public collapse(): void {
    console.log('estoy en mobile', this.isCollapsed);
    this.isCollapsed = !this.isCollapsed;
    const navbar = document.getElementsByTagName('nav')[0];
    if (this.isCollapsed) {
      //navbar.classList.remove('navbar-transparent');
      //navbar.classList.add('bg-gray');
    } else {
      navbar.classList.add('navbar-transparent');
      navbar.classList.remove('bg-white');
    }
  }

  /**
   * Abre el sidebar del aplicativo, solo versión responsive
   * @returns {void}
   */
  private sidebarOpen(): void {
    const toggleButton = this.toggleButton;
    const mainPanel = <HTMLElement>document.getElementsByClassName('main-panel')[0];
    const html = document.getElementsByTagName('html')[0];
    setTimeout(() => {
      toggleButton.classList.add('toggled');
    }, 500);
    html.classList.add('nav-open');
    this.sidebarVisible = true;
  }

  /**
   * Cierra el sidebar del aplicativo, solo versión responsive
   * @returns {void}
   */
  private sidebarClose(): void {
    const html = document.getElementsByTagName('html')[0];
    this.toggleButton.classList.remove('toggled');
    const mainPanel = <HTMLElement>document.getElementsByClassName('main-panel')[0];
    this.sidebarVisible = false;
    html.classList.remove('nav-open');
  }

  /**
   * Sidebar Toggle
   * @returns {void}
   */
  public sidebarToggle(): void {
    let $toggle = document.getElementsByClassName('navbar-toggler')[0];
    !this.sidebarVisible ? this.sidebarOpen() : this.sidebarClose();
    const html = document.getElementsByTagName('html')[0];
    if (this.mobile_menu_visible === 1) {
      html.classList.remove('nav-open');
      if ($layer) $layer.remove();
      setTimeout(() => {
        $toggle.classList.remove('toggled');
      }, 400);
      this.mobile_menu_visible = 0;
    } else {
      setTimeout(() => {
        $toggle.classList.add('toggled');
      }, 430);
      var $layer = document.createElement('div');
      $layer.setAttribute('id', 'bodyClick');
      if (html.getElementsByTagName('body')) document.getElementsByTagName('body')[0].appendChild($layer);
      $layer.onclick = function () {
        html.classList.remove('nav-open');
        this.mobile_menu_visible = 0;
        setTimeout(() => {
          $layer.remove();
          $toggle.classList.remove('toggled');
        }, 400);
        const mainPanel = <HTMLElement>document.getElementsByClassName('main-panel')[0];
        if (window.innerWidth < 991) {
          setTimeout(() => {
            mainPanel.style.position = '';
          }, 500);
        }
      }.bind(this);
      html.classList.add('nav-open');
      this.mobile_menu_visible = 1;
    }
  }

  /**
   * Permite cambiar el idioma del aplicativo
   * @param {string} lang
   * @return {void}
   */
  public changeLanguage(lang: string): void {
    //TODO->Guardar Lenguaje en el localStorage
    this._translation.changeLocale(lang);
    this._translate.use(lang);
    this._localStorage.setItem('language', lang);
  }

  /**
   * Se valida si se muestra el Tooltips
   * @param {string} option - Opción a traducir
   * @returns {string}
   */
  public getTooltipMessage(option: string): string {
    return (!this.isCollapsed ? `GeneralOriginal.${option}` : null)
  }

  private sidebarCloseCleanup(): void {
    this.sidebarClose();
    const layer = document.getElementById('bodyClick');
    if (layer) {
      layer.remove();
      this.mobile_menu_visible = 0;
    }
  }
}
